export default __webpack_public_path__ + "static/media/GIF_4.5649d6a4.mp4";